import { useNavigate } from "react-router-dom";

import { RouteConstant } from "@/routes/routeConstant";

import { Layout, LoginForm } from "../components";
import { Link } from "@/components/Elements";

export const Login = () => {
  const navigate = useNavigate();

  return (
    <Layout title="Log in to your account">
      <LoginForm onSuccess={() => navigate(RouteConstant.Landing)} />
      <div className="flex justify-center mt-[5px] items-center italic text-[14px]">
        <Link to={RouteConstant.Register}>Create user account</Link>
        &nbsp;|&nbsp;
        <Link to={RouteConstant.MerchantRegister}>Create merchant account</Link>
      </div>
    </Layout>
  );
};
